<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-10-08 11:42:01
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-10-11 21:26:04
 * @FilePath     : \youxi\youxi\src\views\XXHavingYou\Dialog.vue
 * @Description  : Description
-->
<template>
  <div class="xxhy-dialog">
    <div :class="`xxhy-dialog-${type}`">
      <img
        class="xxhy-dialog-close"
        :class="{ 'xxhy-dialog-close-3': type === 3 }"
        @click="$emit('close')"
        :src="require(`./img/dialog-close${type === 3 ? '-3' : ''}.png`)"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="less">
.xxhy-dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 199;
  background: rgba(0, 0, 0, 0.81);
  &-close {
    cursor: pointer;
    position: absolute;
    right: -60px;
    top: -20px;
    z-index: 29;
    &-3{
      top: auto;
      right: auto;
      bottom: -50px;
      left: 160px;
    }
  }
  &-1 {
    width: 1050px;
    height: 644px;
    background: url("./img/dialog-bg1.png");
    background-size: 100% 100%;
    position: relative;
  }
  &-2 {
    width: 622px;
    min-height: 530px;
    background: url("./img/dialog-bg2.png");
    background-size: 100% 100%;
    position: relative;
  }
  &-3 {
    width: 370px;
    height: 500px;
    position: relative;
  }
  &-4 {
    width: 700px;
    height: 700px;
    position: relative;
  }
}
</style>
